import { useLang } from '@/i18n';
import EFXStream from 'elem/ui-assets/icons/unregular/EFXStream';
import EfSection from 'elem/ui/ef-section';
import EfSpec from 'elem/ui/ef-spec';
import { useRouter } from 'next/router';
import imgLocale1 from '../D/imgs/img1';
import imgLocale2 from '../D/imgs/img2';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('delta3series');
    const { locale = 'us' } = useRouter();
    const img1 = imgLocale1[locale] || imgLocale1['eu'];
    const img2 = imgLocale2[locale] || imgLocale2['eu'];
    const items = [
        {
            pc: img1.pc,
            h5: img1.h5,
            title: t.rich('D_item1_title', {
                b: (tx: string) => <span className="b">{tx}</span>,
                sup: (tx: string) => <sup className="sup">{tx}</sup>,
            }),
            desc: t('D_item1_desc'),
        },
        {
            pc: img2.pc,
            h5: img2.h5,
            title: t.rich('D_item2_title', {
                b: (tx: string) => <span className="b">{tx}</span>,
                sup: (tx: string) => <sup className="sup">{tx}</sup>,
            }),
            desc: t('D_item2_desc'),
        },
    ];

    return (
        <div className={styles.TheComp}>
            <EfSpec className="spec-m" />
            <ul className="items">
                {items.map((item: any, k: number) => (
                    <div key={k}>
                        {k !== 0 && <EfSpec className="spec-m" />}
                        {k === 0 && <EFXStream className="logo" />}
                        <EfSection {...item} hasAnimation={false} />
                    </div>
                ))}
            </ul>
        </div>
    );
}
